import { ConfigManagerV2WhitelistConfig } from './whitelist.model';

export const CONFIG_MANAGER_V2_WHITELIST: ConfigManagerV2WhitelistConfig = {
  teamEmailHashes: [
    // '47a4519f042387a2ebf58afbc281e30d', // inge.heeringa@socialpoint.es
    // '39d94d005d714018890f74542d616c1e', // tamara.garcia@socialpoint.es
    '21e82d2573e697c260edd60962d7272e', // pau.tena@socialpoint.es
    '3b529574e854df4b6506e7b85b5ca6a2', // eric.pinto@socialpoint.es
    // '8c4ac87cf636d9eb40d9f2b41ec84568', // miguel.arregui@socialpoint.es
    'd7916831b9cfff72e1b2c60c5cadcf78', // jordi.forns@socialpoint.es
    // 'f7e65a59ead520c9a4aaf42d199e7ec2', // aitor.suso@socialpoint.es
    '4233c9738e1186ab451c488a28aa1ad6', // foo.bar@socialpoint.es
  ],

  projectsByEndpoint: {
    // Branch operations
    getBranches: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    getBranch: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    forkBranch: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    deleteBranch: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    // Config operations
    getConfigs: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    addConfig: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    renameConfig: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    deleteConfig: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    // Section operations
    getSections: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    getSection: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    addSection: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    putSection: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    renameSection: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    deleteSection: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    // Link operations
    getBranchLinks: [
      'demo',
      'wordlife',
      'monstercity',
      'dragoncity',
      'twodots',
    ],
    getSectionLinks: [
      'demo',
      'wordlife',
      'monstercity',
      'dragoncity',
      'twodots',
    ],
    updateLink: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
    deleteLink: ['demo', 'wordlife', 'monstercity', 'dragoncity', 'twodots'],
  },
};
